/**
 * React Application Entry Point (Vite)
 * 
 * This is the entry point of the React application where the App component
 * is rendered to the DOM.
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import 'flag-icons/css/flag-icons.min.css'
import './css/global.css'
import App from './App'
import { AuthProvider } from './context/AuthContext'
import ErrorBoundary from './components/ErrorBoundary'

const rootElement = document.getElementById('root');

if (!rootElement) {
    console.error('Fatal: #root element not found in DOM!');
} else {
    ReactDOM.createRoot(rootElement).render(
        <React.StrictMode>
            <ErrorBoundary>
                <AuthProvider>
                    <App />
                </AuthProvider>
            </ErrorBoundary>
        </React.StrictMode>
    )
}
